import { render } from "./BaseCard.vue?vue&type=template&id=0e952e1a&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=0e952e1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e952e1a"]])

export default __exports__